'use strict'

export class CustomerService {
  constructor($q, $http, CustomerFactory) {
    'ngInject'
    Object.assign(this, { $q, $http, CustomerFactory })
  }

  load(customerId, companyId) {
    if (this.current && this.current.customerId === customerId && this.current.companyId === companyId)
      return this.$q.when(this.current)

    return this.$http({
      method: 'GET',
      url: '/api/companies/' + companyId + '/customers/' + customerId,
    }).then((result) => {
      this.current = new this.CustomerFactory(result.data)
      Object.assign(this.current, { companyId, customerId })
      return this.current
    })
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/customer.service.js